<template>
  <div>
    <apexchart
      type="radialBar"
      :series="series"
      :options="chartOptions"
      class="apex-charts"
    />
    <div class="center">
      <p v-if="loading" class="bold">
        Carregando...
      </p>
      <p v-else class="bold top-10" :style=" efficiency < 31 ? 'color: #D9534F' : efficiency > 30 && efficiency < 70 ?  'color: #FFDC5D' : 'color: #26e7a6'">
        {{ efficiency }}% <br />
      </p>
      <p v-if="!loading" class="bold top--10" :style=" efficiency < 31 ? 'color: #D9534F' : efficiency > 30 && efficiency < 70 ?  'color: #FFDC5D' : 'color: #26e7a6'">
        {{efficiency < 31 ? 'Ineficiente' : efficiency > 30 && efficiency < 70 ? 'Parcialmente Eficiente' : 'Eficiente'}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    efficiency: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      series: [this.efficiency],
      chartOptions: {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true,
          },
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: '#e7e7e7',
              strokeWidth: '97%',
              margin: 5,
              dropShadow: {
                enabled: true,
                top: 2,
                left: 1,
                color: '#999',
                opacity: 0.4,
                blur: 2,
              },
            },
            dataLabels: {
              showOn: 'always',

              name: {
                show: false,
                color: '#888',
                fontSize: '15px',
              },
              value: {
                show: false,
                color: '#888',
                offsetY: -65,
                fontSize: '15px',
                formatter: function (val, opts) {
                  return val < 40
                    ? `${val}% (Ineficiente)`
                    : val > 39 && val < 70
                    ? `${val}% (Parcialmente Eficiente)`
                    : val + '% (Eficiente)'
                },
              },
            },
          },
        },
        grid: {
          padding: {
            top: -10,
          },
        },
        fill: {
          type: 'gradient',
          colors: [
            function ({ value, seriesIndex, w }) {
              if (value < 40) {
                return '#D9534F'
              } else if (value >= 40 && value < 70) {
                return '#FFDC5D'
              } else {
                return '#26e7a6'
              }
            },
          ],
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91],
          },
        },
        labels: ['Eficiência de Estoque'],
      },
    }
  },
}
</script>

<style>
.center{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.bold{
  font-weight: bold;
}
.top--10{
  margin-top: -10px;
}
.top-10{
  margin-top: 10px;
}
</style>